import { ISelectOption } from '@apps-common/types/form'

export const TRIGGER_TYPE_ARM_DISARM = { label: 'Alarm Arm/Disarm', value: 'arm-disarm' }
export const TRIGGER_TYPE_EVENT = { label: 'CID Event', value: 'event' }

export const UNIT_TRIGGER_TYPES: ISelectOption[] = [TRIGGER_TYPE_ARM_DISARM, TRIGGER_TYPE_EVENT]

export const UNIT_TRIGGER_ACTION_DELAYS: ISelectOption[] = [
  { value: 0, label: 'No Delay' },
  { value: 15, label: '15 Seconds' },
  { value: 30, label: '30 Seconds' },
  { value: 60, label: '60 Seconds' }
]
